import { html } from '@webtides/element-js';
import FormField from '../form-field/form-field.class';
import { ifDefined } from 'lit-html/directives/if-defined';
import { classMap } from 'lit-html/directives/class-map.js';
import style from './input-field.css';

export default class InputField extends FormField {
    constructor(options) {
        super({ shadowRender: false, styles: [style], ...options });
    }

    properties() {
        return {
            ...super.properties(),
            type: 'text',
            placeholder: 'placeholder',
            minlength: false,
            maxlength: false,
            pattern: false,
        };
    }

    get isValid() {
        const {
            validity: { valid },
            value,
            minLength,
            maxLength,
        } = this.$refs.input;

        // return valid;
        return (
            valid &&
            (minLength > -1 ? value.length >= minLength : true) &&
            (maxLength > -1 ? value.length <= maxLength : true)
        );
    }

    validIndicatorTemplate() {
        return html` <svg-icon name="check" class="valid h-4 w-4"></svg-icon> `;
    }

    invalidIndicatorTemplate() {
        return html` <svg-icon name="close" class="invalid h-4 w-4" data-clear-input></svg-icon> `;
    }

    fieldTemplate() {
        const classes = { 'is-valid': !!this.valid, 'is-invalid': !this.valid };
        return html`
            <input
                ref="input"
                id="input-${this.name}"
                name="${this.name}"
                type="${this.type}"
                value="${this.value}"
                placeholder="${this.placeholder}"
                ?required="${this.required}"
                ?disabled="${this.disabled}"
                aria-describedby="${this.name}-help"
                pattern=${ifDefined(this.pattern ? this.pattern : undefined)}
                minlength=${ifDefined(this.minlength ? this.minlength : undefined)}
                maxlength=${ifDefined(this.maxlength ? this.maxlength : undefined)}
            />
            ${this.touched
                ? html`
                      <div class="validity ${classMap(classes)}">
                          ${this.valid ? this.validIndicatorTemplate() : this.invalidIndicatorTemplate()}
                      </div>
                  `
                : ''}
        `;
    }
}
